/**
 * Purpose: Renders the ACTIVE dashboard module from a resolved descriptor list.
 *          Mirrors the detail-page ModuleRenderer, with one deliberate
 *          difference: the dashboard shows one module at a time (nav-driven),
 *          so there is no IntersectionObserver gate — only the active chunk is
 *          ever downloaded, which is a stronger performance property.
 * Inputs: modules (resolved descriptors), activeId, ctx, moduleProps.
 * Outputs: a single tabpanel with a Suspense skeleton while the chunk loads.
 *          Renders nothing if the active id resolves to no module.
 */
import React, { Suspense } from 'react';
import { ModulePanelSkeleton } from './DashboardSkeleton';

const DashboardModuleRenderer = ({ modules = [], activeId, ctx, moduleProps = {} }) => {
  const module = modules.find((m) => m.id === activeId);
  if (!module) return null;

  return (
    <div
      role="tabpanel"
      id={`dashboard-panel-${module.id}`}
      aria-label={module.title(ctx)}
      tabIndex={-1}
    >
      <Suspense fallback={<ModulePanelSkeleton />}>
        <module.Component title={module.title(ctx)} ctx={ctx} {...moduleProps} />
      </Suspense>
    </div>
  );
};

export default DashboardModuleRenderer;
